import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { BidRange, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './range.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class RangeComponent extends RepositoryModal<BidRange> {
    protected onBeforeSave(): boolean {
        if (this.target.low >= this.target.high) {
            this.services.notification.error('Low value must be lower than the High value.')
            return false
        }
        return true
    }
}
